<template>
  <base-button type="reset" class="btn-dark" text="リセット" />
</template>

<script>
import BaseButton from '@/views/atoms/BaseButton';

export default {
  name: 'ResetButton',
  components: {
    BaseButton,
  },
}
</script>
